import { Injectable } from '@angular/core';

import { toFixed } from '../../../core/services/utils/numbers';

@Injectable({
    providedIn: 'root'
})
export class MetaCalculoService {

    /** Calcula o percentual da quantidade realizada da meta */
    calcularQuantidadeRealizadaPerc(quantidadeRealizada: number, quantidadeMeta: number): number {
        quantidadeRealizada = quantidadeRealizada && !isNaN(quantidadeRealizada) ? Number(quantidadeRealizada) : 0;
        quantidadeMeta = quantidadeMeta && !isNaN(quantidadeMeta) ? Number(quantidadeMeta) : 0;

        // Sem quantidade na meta
        if (quantidadeMeta === 0) {
            return 0;
        }

        const perc = (quantidadeRealizada / quantidadeMeta) * 100;
        return toFixed(perc, 2);
    }

    /** Calcula o percentual do peso realizado da meta */
    calcularPesoRealizadoPerc(pesoRealizado: number, pesoMeta: number): number {
        pesoRealizado = pesoRealizado && !isNaN(pesoRealizado) ? Number(pesoRealizado) : 0;
        pesoMeta = pesoMeta && !isNaN(pesoMeta) ? Number(pesoMeta) : 0;

        // Sem peso na meta
        if (pesoMeta === 0) {
            return 0;
        }

        const perc = (pesoRealizado / pesoMeta) * 100;
        return toFixed(perc, 2);
    }


    /** Calcula o percentual do valor realizado da meta */
    calcularValorRealizadoPerc(valorRealizado: number, valorMeta: number): number {
        valorRealizado = valorRealizado && !isNaN(valorRealizado) ? Number(valorRealizado) : 0;
        valorMeta = valorMeta && !isNaN(valorMeta) ? Number(valorMeta) : 0;

        // Sem valor na meta
        if (valorMeta === 0) {
            return 0;
        }

        const perc = (valorRealizado / valorMeta) * 100;
        return toFixed(perc, 2);
    }

}
